<ng-container *ngIf="event?.show">
  <div class="p-2 bg-light notify-user-xxl">
    <nz-alert [nzType]="event.type" [nzMessage]="event.message" nzShowIcon="true"></nz-alert>
  </div>
</ng-container>
